<template>
	<div
		class="MobileModal"
		role="dialog"
		aria-modal="true"
		aria-label="Mobile Modal"
	>
		<div class="Header">
			<button
				class="CloseButton"
				aria-label="Close Modal"
				@click="$emit('close')"
			>
				<i class="lnr-cross" aria-hidden="true"></i>
			</button>
		</div>
		<div
			v-scrollbar
			:class="['Content', { 'withFooter': hasFooter }]"
		>
			<slot />
		</div>
		<MobileModalFooter v-if="hasFooter" />
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import MobileModalFooter from './MobileModalFooter/MobileModalFooter.vue';
import { useMobileModal } from '@app/composables/useMobileModal';
const { modalState } = useMobileModal();
const hasFooter = computed(() => {
	return !!modalState.value.props.footer;
});
</script>

<style scoped lang="scss">
	.MobileModal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: $PentHouse;
		background: $Grey-100;
		display: flex;
		flex-direction: column;

		.Content {
			flex: 1;
			overflow-y: auto;
			position: relative;
			-webkit-overflow-scrolling: touch;

			&.withFooter {
				@include MarginAreas(0, 0, 5, 0);
			}

			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		.Header {
			display: flex;
			background: $White;
			height: 3.5rem;
			align-items: center;
			justify-content: flex-end;
			border-bottom: 1px solid $Grey-300;

			@include PaddingAreas(0, 1);

			.CloseButton {
				height: 2rem;
				width: 2rem;
				cursor: pointer;
				border-radius: 0.25rem;
				border: 1px solid $Grey-200;
				background: $White;

				@include PaddingAreas(0.5);
			}
		}
	}
</style>
